import events from "@trinitymirrordigital/chameleon-core/src/js/events.js";
import utilities from "@trinitymirrordigital/chameleon-utilities/dist/js/utilities.js";

export function init() {
  var options = {
    debounce: {
      resize: 250,
      scroll: 5,
      scrollChange: 500,
    },
    scrollDirection: null,
    topScrollOffset: {
      previous: 0,
    },
  };
  // Resize stop
  window.addEventListener(
    "resize",
    utilities.debounce(function () {
      // if(window.orientation === undefined){
      //   // Remove a processing class from the body the moment resizing finishes
      //   document.body.classList.remove('processing');
      // }

      events.fire(window, "resize.stop");
    }, options.debounce.resize)
  );

  // Scroll stop
  window.addEventListener(
    "scroll",
    utilities.debounce(function () {
      events.fire(window, "scroll.stop");
    }, options.debounce.scroll)
  );
}
